var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ]
    },
    [
      _vm.fieldLoaded
        ? _c(
            "div",
            [
              _c("DeleteDialog", {
                attrs: {
                  title: "Löschen",
                  text: "Einheit wirklich löschen?",
                  deleteMode: _vm.deleteMode,
                  confirmCallback: _vm.deleteConfirmCallback
                }
              }),
              _vm._v(" "),
              _c("PanelForm", {
                attrs: {
                  formVisible: _vm.showForm,
                  formData: _vm.editPanelData,
                  panelStatuses: _vm.panelStatuses
                }
              }),
              _vm._v(" "),
              _c("Breadcrumb"),
              _vm._v(" "),
              _c(
                "el-card",
                { attrs: { shadow: "always" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      attrs: { slot: "header" },
                      slot: "header"
                    },
                    [
                      _c("span", [
                        _vm._v(
                          "Sektor " +
                            _vm._s(_vm.field ? _vm.field.field_number : "")
                        )
                      ]),
                      _vm._v(" "),
                      _vm.user_is_admin
                        ? _c(
                            "el-button",
                            {
                              staticStyle: { float: "right", padding: "3px 0" },
                              attrs: { type: "text" },
                              on: { click: _vm.addPanelClickHandler }
                            },
                            [_vm._v("Einheit hinzufügen")]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form",
                    { ref: "inputErrors", attrs: { model: _vm.inputErrors } },
                    [
                      _c(
                        "el-row",
                        { attrs: { type: "flex", justify: "space-between" } },
                        [
                          _c("el-col", [
                            _c(
                              "span",
                              { staticStyle: { "font-size": "16px" } },
                              [
                                _vm._v(
                                  "Adresse des Gebäudes: " +
                                    _vm._s(_vm.building.street) +
                                    " " +
                                    _vm._s(_vm.building.house_number) +
                                    " " +
                                    _vm._s(_vm.building.suffix)
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("el-col", [
                            _c(
                              "p",
                              {
                                staticStyle: {
                                  "font-size": "16px",
                                  "text-align": "right"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            Total\n                            "
                                ),
                                _c("el-tag", { attrs: { size: "small" } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.field
                                        ? _vm.field.number_of_panels
                                        : ""
                                    )
                                  )
                                ])
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { attrs: { type: "flex", justify: "space-between" } },
                        [
                          _c("el-col", [
                            _c("div", { staticClass: "panel-box" }, [
                              _c("p", [
                                _c("span", { staticClass: "available" }),
                                _vm._v(
                                  " available\n                                "
                                ),
                                _c("span", { staticClass: "locked" }),
                                _vm._v(
                                  " locked\n                                "
                                ),
                                _c("span", { staticClass: "reserved" }),
                                _vm._v(
                                  " reserved\n                                "
                                ),
                                _c("span", { staticClass: "taken" }),
                                _vm._v(" taken\n                            ")
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("el-col", [
                            _c(
                              "p",
                              {
                                staticStyle: {
                                  "font-size": "16px",
                                  "text-align": "right"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            Available\n                            "
                                ),
                                _c(
                                  "el-tag",
                                  { attrs: { size: "small", type: "success" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.field
                                          ? _vm.field.available_panels
                                          : ""
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("el-row"),
                      _vm._v(" "),
                      _c("el-row"),
                      _vm._v(" "),
                      _vm.field
                        ? _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            _vm._l(_vm.field.panels, function(panel) {
                              return _c(
                                "el-col",
                                {
                                  key: panel.id,
                                  attrs: { span: 6, "v-model": panel }
                                },
                                [
                                  _c(
                                    "el-card",
                                    { staticClass: "panel-box" },
                                    [
                                      _c(
                                        "el-row",
                                        {
                                          staticStyle: { "margin-bottom": "0" },
                                          attrs: {
                                            type: "flex",
                                            justify: "space-between"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-col",
                                            {
                                              staticClass: "clickable",
                                              attrs: { span: 16 },
                                              nativeOn: {
                                                click: function($event) {
                                                  return _vm.updatePanelClickHandler(
                                                    panel
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "el-tooltip",
                                                {
                                                  attrs: {
                                                    content: panel.status_name,
                                                    placement: "top",
                                                    effect: "light"
                                                  }
                                                },
                                                [
                                                  _c("span", {
                                                    class: panel.status_name
                                                  })
                                                ]
                                              ),
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(panel.panel_number) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.getPanelName(panel)
                                                  ) +
                                                  "\n                                "
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-col",
                                            {
                                              staticClass: "clickable",
                                              attrs: { span: 6 },
                                              nativeOn: {
                                                click: function($event) {
                                                  return _vm.updatePanelClickHandler(
                                                    panel
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(panel.panel_cost) +
                                                  "\n                                "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.user_is_admin
                                            ? _c(
                                                "el-col",
                                                {
                                                  attrs: { span: 2, offset: 2 }
                                                },
                                                [
                                                  _c("DeleteBtn", {
                                                    on: {
                                                      clicked: function(
                                                        $event
                                                      ) {
                                                        return _vm.deleteClickHandler(
                                                          panel
                                                        )
                                                      }
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-260eccff", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-260eccff","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/fields/Field.vue
// module id = null
// module chunks = 